import AttendanceView from '@/components/teacherPage/AttendanceView'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/teacher/markabsent')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AttendanceView />
}
